<template>
  <section style="padding:0 15px;">
    <table class="personnel-table" v-if="form">
      <tbody>
        <tr class="firstRow">
          <td width="100" valign="center" colspan="2">
            <p>
              <span>姓 &nbsp;名</span>
            </p>
          </td>
          <td width="91" valign="center" colspan="2">
            {{ form.name }}
          </td>
          <td width="120" valign="center">
            <p>
              <span>性别</span>
            </p>
          </td>
          <td width="66" valign="center" colspan="2">
            {{ form.sex }}
          </td>
          <td width="85" valign="center" rowspan="2">
            <p>
              <span>户籍所在地</span>
            </p>
          </td>
          <td width="160" valign="center" rowspan="2">
            <el-input type="textarea" :rows="2" placeholder="户籍所在地" v-model="form.birthAddress">
            </el-input>
          </td>
          <td width="130" valign="center" rowspan="6">
            <div class="avatar-img">
              <img v-if="form.img" width="130" height="170" :src="form.img" />
              <img v-else width="130" height="170" src="../../../assets/images/defaultAvatar.jpg" alt="">
              <el-upload style="margin-right:5px;" class="avatar-upload" :action="uploadUrl" :data="{ name:'' }"
                :on-success="handleAvatarSuccess" :show-file-list="false">
                <el-button size="mini" type="primary" :loading="isUpload">上传头像</el-button>
              </el-upload>
            </div>
          </td>
        </tr>
        <tr>
          <td width="88" valign="center" colspan="2">
            <p>
              <span>民 &nbsp;族</span>
            </p>
          </td>
          <td width="91" valign="center" colspan="2">
            <el-select size="small" v-model="form.nation" placeholder="请选择">
              <el-option v-for="item in mzArr" :key="item" :label="item" :value="item">
              </el-option>
            </el-select>
          </td>
          <td width="66" valign="center">
            <p>
              <span>籍贯</span>
            </p>
          </td>
          <td width="66" valign="center" colspan="2">
            <el-input size="small" placeholder="请输入籍贯" v-model="form.birthPlace"></el-input>
          </td>
        </tr>
        <tr>
          <td width="88" valign="center" colspan="2">
            <p>
              <span>政治面貌</span>
            </p>
          </td>
          <td width="157" valign="center" colspan="3">
            <el-select size="small" v-model="form.zzmm" placeholder="请选择">
              <el-option v-for="item in zzmmArr" :key="item" :label="item" :value="item">
              </el-option>
            </el-select>
          </td>
          <td width="151" valign="center" colspan="3">
            <p>
              <span>入（团）党时间</span>
            </p>
          </td>
          <td width="160" valign="center">
            <el-date-picker size="small" v-model="form.joinPartyTime" value-format="yyyy-MM-dd" type="date"
              placeholder="选择年月">
            </el-date-picker>
          </td>
        </tr>
        <tr>
          <td width="88" valign="center" colspan="2">
            <p>
              <span>身份证号码</span>
            </p>
          </td>
          <td width="157" valign="center" colspan="3">
            <el-input size="small" placeholder="请输入身份证号" v-model="form.idCard"></el-input>
          </td>
          <td width="151" valign="center" colspan="3">
            <p>
              <span>手机</span>
            </p>
          </td>
          <td width="160" valign="center">
            <el-input type="number" placeholder="请输入手机号" size="small" v-model="form.phone"></el-input>
          </td>
        </tr>

        <tr>
          <td width="88" valign="center" colspan="2">
            <p>
              <span>紧急联系人</span>
            </p>
          </td>
          <td width="157" valign="center" colspan="3">
            <el-input size="small" placeholder="请输入紧急联系人" v-model="form.linkman"></el-input>
          </td>
          <td width="151" valign="center" colspan="3">
            <p>
              <span>紧急联系方式</span>
            </p>
          </td>
          <td width="160" valign="center">
            <el-input type="number" placeholder="请输入紧急联系方式" size="small" v-model="form.linkPhone"></el-input>
          </td>
        </tr>


        <tr>
          <td width="88" valign="center" colspan="2">
            <p>
              <span>进公司时间</span>
            </p>
          </td>
          <td width="157" valign="center" colspan="3">
            <el-date-picker size="small" v-model="form.joinTime" value-format="yyyy-MM-dd" type="date"
              placeholder="选择年月">
            </el-date-picker>
          </td>
          <td width="151" valign="center" colspan="3">
            <p>
              <span>转正时间</span>
            </p>
          </td>
          <td width="160" valign="center">
            <el-date-picker size="small" v-model="form.zzTime" value-format="yyyy-MM-dd" type="date" placeholder="选择年月">
            </el-date-picker>
          </td>
        </tr>


        <tr>
          <td width="88" valign="center" colspan="2">
            <p>
              <span>电子邮件</span>
            </p>
          </td>
          <td width="157" valign="center" colspan="3">
            <el-input type="" size="small" placeholder="请输入电子邮件" v-model="form.email"></el-input>
          </td>
          <td width="151" valign="center" colspan="3">
            <p>
              <span>婚姻状况</span>
            </p>
          </td>
          <td width="273" valign="center" colspan="2">
            <el-select size="small" v-model="form.marriage" placeholder="请选择">
              <el-option v-for="item in hyzkArr" :key="item" :label="item" :value="item">
              </el-option>
            </el-select>
          </td>
        </tr>

        <tr>
          <td width="88" valign="center" colspan="2">
            <p>
              <span>家庭电话</span>
            </p>
          </td>
          <td width="157" valign="center" colspan="3">
            <el-input type="number" size="small" placeholder="请输入家庭电话" v-model="form.tel"></el-input>
          </td>
          <td width="151" valign="center" colspan="3">
            <p>
              <span>家庭地址</span>
            </p>
          </td>
          <td width="273" valign="center" colspan="2">
            <el-input type="textarea" :rows="2" placeholder="户籍所在地" v-model="form.homeAddress">
            </el-input>
          </td>
        </tr>

        <tr>
          <td width="88" valign="center" colspan="2" rowspan="2">
            <p>
              <span>学历</span>
            </p>
            <p>
              <span>学位</span>
            </p>
          </td>
          <td width="91" valign="center" colspan="2">
            <p>
              <span>全日制教育</span>
            </p>
          </td>
          <td width="66" valign="center">
            <el-select size="small" v-model="form.fullEdu" placeholder="请选择">
              <el-option v-for="item in xlArr" :key="item" :label="item" :value="item">
              </el-option>
            </el-select>
          </td>
          <td width="151" valign="center" colspan="3">
            <p>
              <span>毕业院校系及专业</span>
            </p>
          </td>
          <td width="273" valign="center" colspan="2">
            <el-input size="small" placeholder="请输入" v-model="form.fullSchool"></el-input>
          </td>
        </tr>
        <tr>
          <td width="91" valign="center" colspan="2">
            <p>
              <span>在职教育</span>
            </p>
          </td>
          <td width="66" valign="center">
            <el-select size="small" v-model="form.jobEdu" placeholder="请选择">
              <el-option v-for="item in xlArr" :key="item" :label="item" :value="item">
              </el-option>
            </el-select>
          </td>
          <td width="151" valign="center" colspan="3">
            <p>
              <span>毕业院校系及专业</span>
            </p>
          </td>
          <td width="273" valign="center" colspan="2">
            <el-input size="small" placeholder="请输入" v-model="form.jobSchool"></el-input>
          </td>
        </tr>
        <tr>
          <td width="88" valign="center" colspan="2">
            <p>
              <span>何种岗位证书</span>
            </p>
          </td>
          <td width="157" valign="center" colspan="3">
            <el-input size="small" placeholder="请输入" v-model="form.certificate"></el-input>
          </td>
          <td width="151" valign="center" colspan="3">
            <p>
              <span>何种专业职称</span>
            </p>
          </td>
          <td width="273" valign="center" colspan="2">
            <el-input size="small" placeholder="请输入" v-model="form.position"></el-input>
          </td>
        </tr>


        <tr>
          <td width="35" valign="center" :rowspan="(form.resumes.length<1?1:form.resumes.length)+1">
            <p>
              <span>简历</span>
              <el-button @click="addLists(1)" size="mini" type="primary" icon="el-icon-plus" circle></el-button>
            </p>
          </td>
          <td width="142" valign="center" colspan="4">
            <p>
              <span>何年何月至何年何月</span>
            </p>
          </td>
          <td width="226" valign="center" colspan="3">
            <p>
              <span>何地何单位学习或工作</span>
            </p>
          </td>
          <td width="273" valign="center" colspan="2">
            <p>
              <span>奖惩记录</span>
            </p>
          </td>
        </tr>
        <tr v-for="resume,i in form.resumes">
          <td width="142" valign="center" colspan="4">
            <p>
              <span style="width:110px;display:inline-block;">
                <el-date-picker size="small" v-model="resume.startTime" value-format="yyyy-MM" type="month"
                  placeholder="选择年月">
                </el-date-picker>
              </span>至<span style="width:110px;display:inline-block;">
                <el-date-picker size="small" v-model="resume.endTime" value-format="yyyy-MM" type="month"
                  placeholder="选择年月">
                </el-date-picker>
              </span>
            </p>
          </td>
          <td width="226" valign="center" colspan="3">
            <el-input type="textarea" :rows="1" placeholder="" v-model="resume.workPlace">
            </el-input>
          </td>
          <td width="273" valign="center" colspan="2">
            <el-input type="textarea" :rows="1" placeholder="" v-model="resume.jcRecord">
            </el-input>
          </td>
        </tr>


        <tr v-for="position,i in form.positions">
          <td v-if="i==0" width="35" valign="center" :rowspan="(form.positions.length<1?1:form.positions.length)">
            <p>
              <span>本公司岗位调动情况</span>
              <el-button @click="addLists(2)" size="mini" type="primary" icon="el-icon-plus" circle></el-button>
            </p>
          </td>
          <td width="142" valign="center" colspan="4">
            <p>
              <span style="width:110px;display:inline-block;">
                <el-date-picker size="small" v-model="position.startTime" value-format="yyyy-MM" type="month"
                  placeholder="选择年月">
                </el-date-picker>
              </span>至<span style="width:110px;display:inline-block;">
                <el-date-picker size="small" v-model="position.endTime" value-format="yyyy-MM" type="month"
                  placeholder="选择年月">
                </el-date-picker>
              </span>
            </p>
          </td>
          <td width="226" valign="center" colspan="3">
            <el-input type="textarea" :rows="1" placeholder="请输入" v-model="position.workPlace">
            </el-input>
          </td>

          <td width="273" valign="center" colspan="2" v-if="i==0">
            <p>
              <span>获奖情况</span>
            </p>
          </td>
          <td width="273" valign="center" colspan="2" v-if="i==1" :rowspan="form.positions.length-1">
            <el-input type="textarea" :rows="4" placeholder="请输入" v-model="form.reward">
            </el-input>
          </td>
        </tr>



        <tr>
          <td width="35" valign="center" :rowspan="(form.families.length<1?1:form.families.length)+1">
            <p>
              <span>家庭主要成员</span>
              <el-button @click="addLists(3)" size="mini" type="primary" icon="el-icon-plus" circle></el-button>
            </p>
          </td>
          <td width="80" valign="center">
            <p>
              <span>称谓</span>
            </p>
          </td>
          <td width="82" valign="center">
            <p>
              <span>姓名</span>
            </p>
          </td>
          <td width="111" valign="center" colspan="2">
            <p>
              <span>出生年月</span>
            </p>
          </td>
          <td valign="center" colspan="2">
            <p>
              <span>政治面貌</span>
            </p>
          </td>
          <td valign="center" colspan="2">
            <p>
              <span>工作单位及职务</span>
            </p>
          </td>
          <td valign="center" colspan="2">
            <p>
              <span>联系方式</span>
            </p>
          </td>
        </tr>
        <tr v-for="family,i in form.families">
          <td width="60" valign="center">
            <el-select size="small" v-model="family.callName" placeholder="请选择">
              <el-option v-for="item in cwArr" :key="item" :label="item" :value="item">
              </el-option>
            </el-select>
          </td>
          <td width="82" valign="center">
            <el-input size="small" placeholder="请输入" v-model="family.name"></el-input>
          </td>
          <td width="161" valign="center" colspan="2">
            <el-date-picker size="small" v-model="family.birthday" value-format="yyyy-MM" type="month"
              placeholder="选择年月">
            </el-date-picker>
          </td>
          <td valign="center" colspan="2">
            <el-select size="small" v-model="family.zzmm" placeholder="请选择">
              <el-option v-for="item in zzmmArr" :key="item" :label="item" :value="item">
              </el-option>
            </el-select>
          </td>
          <td valign="center" colspan="2">
            <el-input size="small" placeholder="请输入" v-model="family.job"></el-input>
          </td>
          <td valign="center" colspan="2">
            <el-input size="small" placeholder="请输入" v-model="family.phone"></el-input>
          </td>
        </tr>
      </tbody>
    </table>



  </section>
</template>

<script>
  export default {
    props: ['formByFather'],
    data() {
      return {
        form: '',
        isUpload: false,
        uploadUrl: axios.defaults.baseURL + '/common/upload',
        mzArr: ["汉族", "满族", "蒙古族", "回族", "藏族", "维吾尔族", "苗族", "彝族", "壮族", "布依族", "侗族", "瑶族", "白族", "土家族", "哈尼族", "哈萨克族",
          "傣族", "黎族", "傈僳族", "佤族", "畲族", "高山族", "拉祜族", "水族", "东乡族", "纳西族", "景颇族", "柯尔克孜族", "土族", "达斡尔族", "仫佬族", "羌族",
          "布朗族", "撒拉族", "毛南族", "仡佬族", "锡伯族", "阿昌族", "普米族", "朝鲜族", "塔吉克族", "怒族", "乌孜别克族", "俄罗斯族", "鄂温克族", "德昂族", "保安族",
          "裕固族", "京族", "塔塔尔族", "独龙族", "鄂伦春族", "赫哲族", "门巴族", "珞巴族", "基诺族"
        ],
        zzmmArr: ['中共党员', '共青团员', '普通群众'],
        hyzkArr: ['已婚', '未婚'],
        xlArr: ['博士', '研究生', '本科', '大专', '高中', '中专', '初中', '小学'],
        cwArr: ['配偶','哥哥','弟弟','姐姐','妹妹','父亲', '母亲', '儿子', '女儿', '岳父', '岳母'],
      }
    },
    mounted() {
      this.form = this.formByFather
    },
    methods: {
      // addLists
      addLists(type) {
        switch (type) {
          case 1:
            this.form.resumes.push({
              "endTime": "",
              "jcRecord": "",
              "startTime": "",
              "workPlace": ""
            })
            break;
          case 2:
            this.form.positions.push({
              "endTime": "",
              "startTime": "",
              "workPlace": ""
            })
            break;
          case 3:
            this.form.families.push({
              "birthday": "",
              "callName": "",
              "job": "",
              "name": "",
              "phone": "",
              "zzmm": ""
            })
            break;
          default:
            break;
        }
      },

      // 上传成功回调
      handleAvatarSuccess(res, file) {
        this.isUpload = false
        this.$set(this.form, 'img', res.vo.fileUrl)
      },
      getFromData() {
        return this.form
      }
    },
    watch: {
      formByFather() {
        this.form = this.formByFather
      }
    }
  }
</script>


// WEBPACK FOOTER //
// src/page/form/personnel/userInfo.vue